import React from 'react';
import GP from '../images/clients/GP.png';
import TGS from '../images/clients/3GS.png';
import supreme from '../images/clients/supremeSolution.png';
import zycon from '../images/clients/zyconGlobalManpower.png';

const clients = [
  { img: GP, name: "Green Pellets India" },
  { img: TGS, name: "Three Gee Solutions" },
  { img: supreme, name: "Supreme Solutions, Canada" },
  { img: zycon, name: "Zycon Global Manpower" },
];

const Clients = () => {
  return (
    <section
      id="clients"
      className="relative bg-gradient-to-b from-[#f3f8fc] to-[#e1eef7] py-16 px-6 lg:px-20"
    >
      {/* Section Header */}
      <div className="text-center mb-12" data-aos="fade-up">
        <h2 className="text-4xl font-bold text-[#15467a] uppercase">
          Our Clients
        </h2>
        <div className="w-24 h-1 bg-[#15467a] mx-auto mt-3 rounded-full"></div>
        <p className="mt-6 text-lg text-gray-700 font-medium max-w-2xl mx-auto">
          We are proud to have partnered with industry leaders and innovators.  
          Here are some of the clients who trust us to power their digital success.
        </p>
      </div>

      {/* Clients Grid */}
      <div className="flex flex-col sm:flex-row justify-center items-center gap-12">
        {clients.map((client, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-lg p-6 flex flex-col items-center hover:shadow-xl transition transform hover:scale-105 relative overflow-hidden"
            data-aos="zoom-in"
            data-aos-delay={index * 200}
          >
            {/* Optional glow behind image */}
            <div className="absolute inset-0 bg-[#15467a]/10 blur-2xl rounded-xl -z-10"></div>

            <img
              src={client.img}
              alt={client.name}
              className="max-h-32 w-auto object-contain opacity-80 hover:opacity-100 transition duration-300"
            />
            <h3 className="mt-4 text-xl font-semibold text-[#15467a] text-center">
              {client.name}
            </h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Clients;
